(function () {
  'use strict';

  angular
    .module('app.wishlist', [])

    /* @ngInject */
    .controller('wishlistController', ["$rootScope", "AppService", "toastr", function ($rootScope, AppService, toastr) {
      var ctrl = this;
      ctrl.productsToCart = [];

      ctrl.init = function (lines) {
        ctrl.addAllEnabled = true;
        _.each(lines, function (line) {
          if (!line.Product.AllowAddToCart) {
            ctrl.addAllEnabled = false;
          }
        });
      };

      ctrl.addProduct = function (idProduct) {
        ctrl.productsToCart.push({
          idProduct: idProduct,
          quantity: 1
        });
      };

      ctrl.addAllProducts = function (event) {
        $rootScope.$broadcast('showPageLoader', true);

        var message = $(event.currentTarget).attr('message');

        AppService.addToCart(ctrl.productsToCart)
          .then(function (response) {
            if (response.status === 'OK') {
              AppService.updateParams(response.results);
              toastr.success('', message, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                });
            }
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (error) {
            console.error(error);
          });
      };

    }]);

})();
